/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';

export type SleepSeconds = {
    seconds: number;
};

export const SleepTimeElement: FunctionComponent<SleepSeconds> = ({ seconds }) => (
    <GridContainer>
        <GridItem xs={9}>
            <I18n trans="prov:f.sleep_time" />
        </GridItem>
        <GridItem style={{ textAlign: 'right' }} xs={3}>
            {seconds}s
        </GridItem>
    </GridContainer>
);
